var map = {
	"./en.json": [
		8023,
		"libs_search-and-help-shared-lib_src_lib_modules_incident_assets_i18n_en_json"
	],
	"./pl.json": [
		32773,
		"libs_search-and-help-shared-lib_src_lib_modules_incident_assets_i18n_pl_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 26553;
module.exports = webpackAsyncContext;